import { Observable } from 'rxjs';
import { Component, Input, OnInit } from '@angular/core';
import { Select, Store } from '@ngxs/store';
import { AccountActions, AccountSelectors } from '@serviceos-ng/core';

@Component({
    selector: 'serviceos-web-referral-stats',
    templateUrl: './referral-stats.component.html',
    styleUrls: ['./referral-stats.component.scss'],
})
export class ReferralStatsComponent {
    @Select(AccountSelectors.referralStats)
    referralStats$!: Observable<any>;

    @Input()
    texts = {
        title: 'title',
    };

    constructor(private store: Store) {
        this.store.dispatch(new AccountActions.FetchReferralResults()).subscribe();
    }    
}
